import React from "react"
import movingLogo from "../video/moving_logo.mp4"
import epkVideo from "../video/epk_live_video.mp4"
import techRider from "../images/lowfye_stage_plot.png"
import heroPhoto from "../images/hero_red_web.jpg"
import bioPhoto from "../images/bio_web.jpg"
import { PhotoSection } from "./PhotoSection"
import { PromoVideos } from "./PromoVideos"
import { TrackPlayer } from "./TrackPlayer"
import { VideoPlayer } from "./VideoPlayer"
import { SectionHeader } from "../SectionHeader"
import { About } from "../About"
import { BAND_EMAIL, STREAMING_LINKS } from "../links"
import { scrollToSection } from "../nav/NavBarEpk"
import "./Epk.css"

const bookingLink = `mailto:${BAND_EMAIL}?subject=${encodeURIComponent("Booking inquiry - Lowfye50")}`

const FACTS = [
    { label: "Genre", value: "Nu-metal / Hard rock" },
    { label: "Based in", value: "Nashville, TN" },
    { label: "Producer", value: "Noah Henson" },
]

const FeaturedVideo = () => (
    <div className="lf-epkVideo">
        <VideoPlayer src={epkVideo} label="Lowfye50 live video" />
    </div>
)

export const Epk = () => (
    <>
        <header className="lf-epkHero" style={{ backgroundImage: `url(${heroPhoto})` }}>
            <div className="lf-wrap lf-epkHero__inner">
                <div>
                    <div className="lf-eyebrow">Electronic press kit</div>
                    <video className="lf-epkHero__logo" autoPlay loop muted playsInline>
                        <source src={movingLogo} type="video/mp4" />
                    </video>
                    <div className="lf-epkHero__actions">
                        <a className="lf-btn lf-btn--primary" href={bookingLink}><i className="fas fa-envelope"></i> Book the band</a>
                        <button className="lf-btn" onClick={() => scrollToSection("epk-music")}><i className="fas fa-play"></i> Hear the new music</button>
                    </div>
                </div>

                <dl className="lf-facts">
                    {FACTS.map(fact => (
                        <div key={fact.label}>
                            <dt>{fact.label}</dt>
                            <dd>{fact.value}</dd>
                        </div>
                    ))}
                    <div>
                        <dt>Booking</dt>
                        <dd><a href={bookingLink}>{BAND_EMAIL}</a></dd>
                    </div>
                    <div>
                        <dt>Stream</dt>
                        <dd className="lf-facts__icons">
                            {STREAMING_LINKS.map(link => (
                                <a key={link.name} target="_blank" rel="noreferrer" href={link.href} aria-label={link.name} title={link.name}>
                                    <i className={link.icon}></i>
                                </a>
                            ))}
                        </dd>
                    </div>
                </dl>
            </div>
        </header>

        <section className="lf-section lf-epkAlt lf-epkVideoSection" id="epk-video">
            <div className="lf-wrap">
                <FeaturedVideo />
                <div className="lf-epkSub">{"// SHORTS"}</div>
                <PromoVideos />
            </div>
        </section>

        <section className="lf-section" id="epk-music">
            <div className="lf-wrap">
                <SectionHeader eyebrow="Private preview" title="Music" />
                <TrackPlayer />
            </div>
        </section>

        <About photo={bioPhoto} id="epk-bio" />

        <section className="lf-section lf-epkAlt" id="epk-photos">
            <div className="lf-wrap">
                <SectionHeader eyebrow="Press photos — click to download hi-res" title="Photos" />
                <PhotoSection />
            </div>
        </section>

        <section className="lf-section" id="epk-rider">
            <div className="lf-wrap">
                <SectionHeader eyebrow="Stage plot & inputs" title="Tech Rider" />
                <a className="lf-rider" href={techRider} target="_blank" rel="noreferrer">
                    <img src={techRider} alt="Lowfye50 stage plot" />
                    <span className="lf-rider__open"><i className="fas fa-expand"></i> Open full size</span>
                </a>
            </div>
        </section>

        <section className="lf-epkBook">
            <div className="lf-wrap lf-epkBook__inner">
                <h2>Book<br />Lowfye50.</h2>
                <div>
                    <p>For booking, press and industry inquiries:</p>
                    <a className="lf-epkBook__email" href={bookingLink}>{BAND_EMAIL}</a>
                    <a className="lf-btn lf-btn--primary" href={bookingLink}><i className="fas fa-envelope"></i> Send an inquiry</a>
                </div>
            </div>
        </section>
    </>
)
